module.exports = __webpack_public_path__ + "static/media/exhibition.5160dec2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/exhibition.jpg
// module id = 259
// module chunks = 0